import type { ReactNode } from 'react';
import { defaultShouldDehydrateQuery, type QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider, type Persister } from '@tanstack/react-query-persist-client';
import { CHAVE_ADMIN } from '../lib/admin';
import { VALIDADE_DO_CACHE } from '../lib/offline';

/**
 * O cache do IndexedDB pinta a tela na hora e, logo depois, tudo revalida.
 *
 * Sem a revalidacao, o que voltava do disco contava como fresco pelo
 * `staleTime` (30 s no padrao, 5 min nas preferencias, assinaturas e respostas
 * prontas) e a tela nem perguntava ao servidor. Como o persistidor espera 2 s
 * antes de gravar, salvar uma configuracao e recarregar logo em seguida - o
 * gesto natural de quem quer conferir - mostrava o valor de antes: a resposta
 * pronta excluida voltava, a preferencia parecia nao ter salvo. Achado do e2e
 * de configuracoes, que salva e recarrega cada tela.
 *
 * Sem rede, a revalidacao fica pausada e o cache continua na tela.
 */
export function CachePersistido({
  client,
  persister,
  children,
}: {
  client: QueryClient;
  persister: Persister;
  children: ReactNode;
}) {
  return (
    <PersistQueryClientProvider
      client={client}
      persistOptions={{
        persister,
        maxAge: VALIDADE_DO_CACHE,
        // Dados do painel de admin sao de outros clientes: nao vao para o disco.
        dehydrateOptions: {
          shouldDehydrateQuery: (q) =>
            defaultShouldDehydrateQuery(q) && q.queryKey[0] !== CHAVE_ADMIN,
        },
      }}
      onSuccess={() => void client.invalidateQueries()}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
